import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcClose(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.97 4.97a.75.75 0 1 1 1.06 1.06L13.06 12l5.97 5.97a.75.75 0 1 1-1.06 1.06L12 13.06l-5.97 5.97a.75.75 0 1 1-1.06-1.06L10.94 12 4.97 6.03a.75.75 0 1 1 1.06-1.06L12 10.94z"
  }));
}
var IcClose = createNolIcon(/*#__PURE__*/forwardRef(SvgIcClose));

export { IcClose as I };
